export default {
  'isochrones': {
    'isochrones': 'Isochrones',
    'isochronesReady': 'Isochrones prêt',
    'calculatingIsochrones': 'En train de calculer les isochrones ...',
    'itWasNotPossibleToCalculateIsochronesWithTheDefinedOptions': 'Il n\'a pas été possible de calculer les isochrones avec les options définies. Essayez de définir un(des) isochrone(s) plus petit(s).',
    'couldResolveTheSelectedPlaceAsASuitableCenter': 'Il n\'a pas été possible de résoudre le point sélectionné en tant que centre approprié.',
    'apiError': {
      '2003': 'La superficie d\'un polygone à éviter ne doit pas dépasser 20,0000 kilomètres carrés.',
      '3001': 'Un ou plusieurs paramètres ont une valeur ou un format incorrect.',
      '3004': 'La combinaison du profil, de l\'intervalle et du temps ou de la distance sélectionnée dépasse le maximum pris en charge. Veuillez ajuster les valeurs.',
      '3099': 'Impossible de créer une carte isochrone pour le(s) point(s) et le profil sélectionnés.'
    },
    'genericErrorMsg': 'Il n\'a pas été possible de calculer les isochrones.',
    timeoutError: 'La requête a pris trop de temps et a été abandonnée. Essayez des plages ou des intervalles plus petits.'
  },
}
